export default "__VITE_ASSET__rEhVhGf6__"